import { Injectable, Inject } from '@angular/core';
import { IPerDiemLocale } from './IPerDiemLocal';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '../shared/services/logging/logging.service';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PerDiemLookupService {

  constructor(@Inject(HttpClient) private http: HttpClient
    , @Inject(LoggingService) private log: LoggingService) {
  }
  uri = `${environment.apiLocation}/PerDiemTypeByLocale`;

  public get (): Observable<Array<IPerDiemLocale>> {
    const params = {};

    this.log.verbose({ type: 'PerDiemLookupService:get', uri: this.uri });
    return this.http.get<Array<IPerDiemLocale>>(this.uri)
      .pipe(
        tap(res => this.log.verbose({ type: 'PerDiemLookupService:reponse', res }))
      );
  }
}
